<script>
import $ from 'jquery'
window.$ = window.jQuery = $ // for unit test
require('bootstrap-timepicker')

export default {
  inheritAttrs: false,
  model: { event: 'update' },
  mounted() {
    const vm = this
    this.timepicker = $(this.$el)
      .timepicker({
        minuteStep: 1,
        showMeridian: false,
        icons: {
          up: 'fas fa-chevron-up',
          down: 'fas fa-chevron-down',
        },
      })
      .on('changeTime.timepicker', function(e) {
        vm.$emit('update', e.time.value)
      })
  },
}
</script>

<template>
  <input type="text" class="input cursor-pointer" v-bind="$attrs" readonly />
</template>
